// extracted by mini-css-extract-plugin
export var bgGrey = "HowItWorks-module--bgGrey--zFErK";
export var listItemBody = "HowItWorks-module--listItemBody--HwItS";
export var listItemIcon = "HowItWorks-module--listItemIcon--XmeNz";
export var listItemTitle = "HowItWorks-module--listItemTitle--oSW3Q";
export var listItems = "HowItWorks-module--listItems--lUiq-";